import { COLORS } from "@/app/common/consts/colors";
import type { IconProps } from "./type";

export default function EmptyBox({ color = "lightblack" }: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="219"
      height="170"
      viewBox="0 0 219 170"
      fill="none"
    >
      <path
        d="M4 86V158C4 162.418 7.58172 166 12 166H156M4 86L56 66M4 86H56M156 86L208 66M156 86H56M156 86V166M156 166L208 146V66M56 66H208M56 66V86M56 66L63.0936 11.468C63.6121 7.48226 67.0074 4.5 71.0267 4.5H206.892C211.72 4.5 215.448 8.74425 214.825 13.532L208 66"
        stroke={COLORS[color]}
        strokeWidth="8"
      />
    </svg>
  );
}
